import styled from '@emotion/styled';

export const Ul = styled.ul<{ position?: 'inside' | 'outside' }>`
  padding: 0;
  margin: 0;
  list-style-type: '• ';
  list-style-position: ${({ position }) => position ?? 'inside'};
`;
